<div class="space-holder">
        <span [ngClass]="lambdaError ? 'error':'success'"  *ngIf="show" @fadeIn @fadeOut>{{lambdaMessage}}</span>
</div>